const app = ['power', 'hwpower', 'acmode', 'settemp', 'settemp_cb', 'settemp_hb', 'settemp_co', 'settemp_ho', 'iowslct', 'settemp_fb',
  'settemp_cst', 'settemp_ai', 'hwsettemp', 'temp', 'humi', 'temp_o', 'temp_b', 'hwtemp', 'reseterr', 'softver', 'softver_1', 'softver_2', 'softver_3', 'verdata', 'verdata_1',
  'verdata_2', 'verdata_3', 'model', 'slavenum', 'modelnum', 'powerused', 'voltage', 'voltage_AB', 'voltage_BC', 'voltage_CA', 'totalpower', 'tfrequency', 'cfrequency', 'pqtemp',
  'zptemp', 'xqpressure', 'zxqgr', 'pxgr', 'fjjqgr', 'compel', 'inputcurrent', 'moduletemp', 'subvld_1', 'subvld_2', 'subvld_3', 'subvld_4', 'subvld_5', 'subvld_6', 'subvld_7', 'subvld_8', 'subvld_9',
  'subvld_10', 'subvld_11', 'subvld_12', 'subvld_13', 'subvld_14', 'subvld_15', 'subvld_16', 'subvld_17', 'subvld_18', 'subvld_19', 'subvld_20', 'subvld_21', 'subvld_22', 'subvld_23', 'subvld_24', 'subvld_25', 'subvld_26', 'subvld_27', 'subvld_28', 'subvld_29',
  'subvld_30', 'subvld_31', 'subvld_32']
const doubleType = [2, 3, 4, 5, 10, 11, 12, 13, 14, 61]
const validate = function (table) {
  let pass = true
  let phyaddr = 1
  let read12max = 128
  let read34max = 60
  let needsub1 = false
  let modbusList = []
  let allRow = []
  let errorList = []
  let subvld_1 = 0
  let modelnum = 0
  let slavenum = 0
  let mainDevice = '主机'
  let subDevice = '从机'
  let mibeejson = {Version: '1.0.0', Mibees: [], Name: '', Building: [{ID: 1, Name: '大楼', Floors: [{ID: 1, Name: '新楼层', Rooms: [{ID: 1, Name: '户外', Functions: [{Name: '热泵', Type: 'heatpump', Devices: []}]}]}]}]}
  let modbusjson = {ver: 1, dev: [], portswap: 'n', prot: {protflag: 'none', desc: '', function: 'heatpump', funcname: '热泵', Topology: 'M', submax: 1, readtimeout: 200, writetimeout: 200, writecoil: 5, writehold: 6, readcycle: 5, writestopread: 10, otaprotocol: 0, dir485time: 1000, powerdpid: 0, cmd: [], errcode: {type: 'uint8', blockcodes: [], rule: 1, list: []}, sub_cmd: [], sub_errcode: {type: 'uint8', blockcodes: [], rule: 1, list: []}, sub_stopread: {} }}
  let uart1 = {mode: 'master', baud: '4800', parity: 'N', stop: '1'}
  let uart2 = {mode: 'master', baud: '4800', parity: 'N', stop: '1', slaveid: 1, slavemd: 1 }
  let xml = {desc: '', function: 'heatpump', functionname: '热泵', topology: 'M', submax: 1, desc_en: null, dp: []}
  let errorcode = []

  function checkRequire (cell) {
    if (!cell || !cell.text) {
      cell.style = 0
      pass = false
      return false
    }
    return true
  }

  function checkNumber (cell) {
    if (isNaN(cell.text)) {
      cell.style = 0
      pass = false
      return false
    }
    return true
  }

  function checkSame (arry) {
    if (arry.length == 0) {
      return false
    }
    let firstNum = arry[0]
    for (let i = 1; i < arry.length; i++) {
      if (arry[i] !== firstNum) {
        return false
      }
    }
    return true
  }

  function checkIncrementedByOne (arr) {
    for (let i = 1; i < arr.length; i++) {
      if (arr[i] !== arr[i - 1] + 1) {
        return false
      }
    }
    return true
  }

  function checkInt (cell) {
    if (isNaN(cell.text) || cell.text.indexOf('.') >= 0) {
      cell.style = 0
      pass = false
      return false
    }
    return true
  }

  function checkArray (cell, arry) {
    if (!arry.includes(cell.text)) {
      cell.style = 0
      pass = false
      return false
    } else {
      return true
    }
  }

  function checkRange (cell, min, max) {
    if (checkInt(cell)) {
      const v = parseInt(cell.text)
      if (v < min || v > max) {
        cell.style = 0
        pass = false
        return false
      } else {
        return true
      }
    }
    return false
  }

  function checkDuplicate (cell, arry) {
    if (arry.includes(cell.text)) {
      cell.style = 0
      pass = false
      return false
    } else {
      return true
    }
  }

  function buildCmd (f, type) {
    if (!type) {
      type = '主'
    }
    let list = modbusList.filter(m => { return m.sub.indexOf(type) >= 0 && m.f === f })
    if (list.length > 0) {
      // 1.按照address进行排序
      list.sort((a, b) => {
        return a.address - b.address
      })
      let max = 60
      if (f === 1 || f === 2 || f === 5) {
        max = read12max
      } else {
        max = read34max
      }

      // address去重，并且分割读取
      let address = list.map(i => { return i.address })
      address = Array.from(new Set(address))
      const addSplit = splitArray(address, max, list, type)
      addSplit.forEach(arr => {
        let cmd = {f: f, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1, aif: 0, dp: [], idx: [], wad: [], wfc: [], typ: [], mul: [], ofs: [], wbit: [], bit: [], ech: [], ts: [], rs: [], ftv: [], wr: [], map: []}
        const sub = list.filter(m => { return arr.includes(m.address) })
        if (type === '从') {
          cmd.o = sub[0].suboffset
        }
        sub.forEach(s => {
          if (s.aif == 1) {
            cmd.aif = 1
          }
          cmd.dp.push(s.dp)
          cmd.idx.push(s.address - arr[0])
          cmd.wad.push(s.wad)
          cmd.wfc.push(s.wfc)
          cmd.rs.push(s.rs)
          if (f === 3 || f === 4 || f === 6) {
            cmd.typ.push(s.typ)
            cmd.mul.push(s.mul)
            cmd.ofs.push(s.ofs)
            cmd.ech.push(s.ech)
            cmd.ts.push(s.ts)
            cmd.ftv.push(s.ftv)
            cmd.bit.push(s.bit || 0)
          }
          if (f === 3 || f === 6) {
            cmd.wbit.push(s.wbit)
          }
          cmd.wr.push(s.wr)
          cmd.map.push(s.map)

          // 模块机sub_stopread
          if (type == '主' && xml.submax > 1 && modbusjson.prot.sub_stopread && modbusjson.prot.sub_stopread.rule && modbusjson.prot.sub_stopread.rule > 0 && modbusjson.prot.sub_stopread.rule < 5) {
            if ((modbusjson.prot.sub_stopread.rule === 1 && slavenum == s.dp) ||
            (modbusjson.prot.sub_stopread.rule === 2 && modelnum == s.dp) ||
            (modbusjson.prot.sub_stopread.rule === 3 && subvld_1 == s.dp) ||
            (modbusjson.prot.sub_stopread.rule === 4 && subvld_1 == s.dp)) {
              modbusjson.prot.sub_stopread.grp = modbusjson.prot.cmd.length
              modbusjson.prot.sub_stopread.idx = s.address - arr[0]
              if (modbusjson.prot.sub_stopread.rule === 4 && (f === 1 || f === 2 || f === 5)) {
                modbusjson.prot.sub_stopread.type = 'uint8'
              }
            }
          }
        })
        // 优化数据结构
        if ((f === 3 || f === 4 || f === 6) && doubleType.includes(cmd.typ[cmd.typ.length - 1])) {
          cmd.n += 1
        }
        if (checkIncrementedByOne(cmd.dp)) {
          cmd.dp = cmd.dp[0]
        }
        if (checkSame(cmd.wad) && cmd.wad[0] === -1) {
          delete cmd.wad
          if (f == 2 || f == 4) {
            delete cmd.wr
          }
        }
        if (checkSame(cmd.wfc) && cmd.wfc[0] === 0) {
          delete cmd.wfc
        }
        if (!cmd.typ.includes(27) || (checkSame(cmd.map) && cmd.map[0] === 0)) {
          delete cmd.map
        }
        if (cmd.bit.length === 0) {
          delete cmd.bit
        }
        if (cmd.typ.length > 0) {
          if (!cmd.typ.includes(8)) {
            delete cmd.bit
          }
          if (checkSame(cmd.typ)) {
            if (cmd.typ[0] === 0) {
              delete cmd.typ
            } else {
              cmd.typ = cmd.typ[0]
            }
          }
        } else {
          delete cmd.typ
        }
        if (cmd.mul.length > 0) {
          if (checkSame(cmd.mul)) {
            if (cmd.mul[0] === 1) {
              delete cmd.mul
            } else {
              cmd.mul = cmd.mul[0]
            }
          }
        } else {
          delete cmd.mul
        }
        if (cmd.ofs.length > 0) {
          if (checkSame(cmd.ofs)) {
            if (cmd.ofs[0] === 0) {
              delete cmd.ofs
            } else {
              cmd.ofs = cmd.ofs[0]
            }
          }
        } else {
          delete cmd.ofs
        }
        if (cmd.ech.length > 0) {
          if (checkSame(cmd.ech)) {
            if (cmd.ech[0] === 1) {
              delete cmd.ech
            } else {
              cmd.ech = cmd.ech[0]
            }
          }
        } else {
          delete cmd.ech
        }
        if (cmd.ts.length > 0) {
          if (checkSame(cmd.ts)) {
            if (cmd.ts[0] === 0) {
              delete cmd.ts
            } else {
              cmd.ts = cmd.ts[0]
            }
          }
        } else {
          delete cmd.ts
        }
        if (cmd.rs.length > 0) {
          if (checkSame(cmd.rs)) {
            if (cmd.rs[0] === 0) {
              delete cmd.rs
            } else {
              cmd.rs = cmd.rs[0]
            }
          }
        } else {
          delete cmd.rs
        }
        if (cmd.ftv.length > 0) {
          if (checkSame(cmd.ftv)) {
            if (cmd.ftv[0] === 0) {
              delete cmd.ftv
            } else {
              cmd.ftv = cmd.ftv[0]
            }
          }
        } else {
          delete cmd.ftv
        }
        if (cmd.wbit.length > 0) {
          if (checkSame(cmd.wbit) && cmd.wbit[0] === 0) {
            delete cmd.wbit
          }
        } else {
          delete cmd.wbit
        }
        if (type == '主') {
          modbusjson.prot.cmd.push(cmd)
        } else {
          modbusjson.prot.sub_cmd.push(cmd)
        }
      })
    }
  }

  function buildSub () {
    if (xml.submax > 1) {
      let subs = allRow.map(e => { return e.sub })
      let suboffset = allRow.map(e => { return e.suboffset })
      let errsubs = errorList.map(e => { return e.sub })
      let errsuboffset = errorList.map(e => { return e.suboffset })
      if (checkSame(subs) && subs[0] == '主从' && checkSame(errsubs) && errsubs[0] == '主从' && checkSame(suboffset) && checkSame(errsuboffset) && suboffset[0] == errsuboffset[0]) {
        modbusjson.sub_cmd = 'main'
        modbusjson.sub_offset = suboffset[0]
        modbusjson.sub_errcode = 'main'
      }
      if (modbusjson.prot.sub_stopread && modbusjson.prot.sub_stopread.rule == 5) {
        let existed = xml.dp.filter(d => { return d.name == 'slavenum' })
        if (existed && existed.length > 0) {
          pass = false
        } else {
          let dp = {dpid: 9050, name: 'slavenum', desc: '从机数量', text: null, values: null, type: 2, linkagetype: 'none', max: 15, min: 0, step: 1, unit: '台', xrw: 3, desc_en: null, text_en: null, groupname: '', subhide: 1, healthmin: null, healthmax: null}
          xml.dp.push(dp)
        }
      }
    } else {
      delete modbusjson.sub_cmd
      delete modbusjson.sub_offset
      delete modbusjson.sub_errcode
    }
  }

  function buildError (type) {
    if (errorList.length > 0) {
      // 分割功能码
      let start = 0
      errorcode.push({code: 0, errcode: '', name: xml.desc, desc: '', desc_en: ''})
      let error1 = errorList.filter(e => { return e.f === 1 && e.sub == '主从' })
      let error2 = errorList.filter(e => { return e.f === 2 && e.sub == '主从' })
      let error3 = errorList.filter(e => { return e.f === 3 && e.sub == '主从' })
      let error4 = errorList.filter(e => { return e.f === 4 && e.sub == '主从' })
      let merror1 = errorList.filter(e => { return e.f === 1 && e.sub == '主' })
      let merror2 = errorList.filter(e => { return e.f === 2 && e.sub == '主' })
      let merror3 = errorList.filter(e => { return e.f === 3 && e.sub == '主' })
      let merror4 = errorList.filter(e => { return e.f === 4 && e.sub == '主' })
      if (modbusjson.prot.errcode.rule == 4 || modbusjson.prot.errcode.rule == 3 || (modbusjson.prot.errcode.rule >= 100 && modbusjson.prot.errcode.rule <= 199)) {
        errorcode = errorList.filter(e => { return !e.f }).map(e => { return {code: e.address, errcode: e.errorcode, name: xml.desc, desc: e.desc, desc_en: e.desc_en} })
        errorcode.unshift({code: 0, errcode: '', name: xml.desc, desc: '', desc_en: ''})
      }
      if ((error3.length + error4.length + merror3.length + merror4.length) > (error1.length + error2.length + merror1.length + merror2.length)) {
        modbusjson.prot.errcode.type = 'uint16'
        modbusjson.prot.sub_errcode.type = 'uint16'
      }
      // 循环每个功能码
      if (error1.length > 0) {
        let max = read12max
        error1.sort((a, b) => {
          return a.address - b.address
        })
        let address = error1.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        addSplit.forEach(arr => {
          let cmd = {f: 1, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // 判断故障不连续分割
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          })
          let max
          arr.forEach((sub, index) => {
            const ed = error1.filter(e => { return e.address === sub })
            errorcode.push({code: start + index + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // errorcode.push({code: start + sub - arr[0] + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // max = start + sub - arr[0] + 1
            max = start + index + 1
          })
          start = max
        })
        if (xml.submax > 1) {
          const addSubSplit = splitArray(address, max, error1, '从')
          addSubSplit.forEach(arr => {
            const ed = error1.filter(e => { return e.address === arr[0] })
            let cmd = {f: 1, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1, o: ed[0].suboffset}
            modbusjson.prot.sub_cmd.push(cmd)
            // modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
            const splitSubError = splitArrayOneByOne(arr)
            splitSubError.forEach(earr => {
              modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.sub_errcode.type == 'uint16' ? 'uint8' : undefined})
            })
          })
        }
      }
      if (error2.length > 0) {
        let max = read12max
        error2.sort((a, b) => {
          return a.address - b.address
        })
        let address = error2.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        addSplit.forEach(arr => {
          let cmd = {f: 2, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          })
          let max
          arr.forEach((sub, index) => {
            const ed = error2.filter(e => { return e.address === sub })
            errorcode.push({code: start + index + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // errorcode.push({code: start + sub - arr[0] + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // max = start + sub - arr[0] + 1
            max = start + index + 1
          })
          start = max
        })
        if (xml.submax > 1) {
          const addSubSplit = splitArray(address, max, error2, '从')
          addSubSplit.forEach(arr => {
            const ed = error2.filter(e => { return e.address === arr[0] })
            let cmd = {f: 2, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1, o: ed[0].suboffset}
            modbusjson.prot.sub_cmd.push(cmd)
            // modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
            const splitSubError = splitArrayOneByOne(arr)
            splitSubError.forEach(earr => {
              modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.sub_errcode.type == 'uint16' ? 'uint8' : undefined})
            })
          })
        }
      }
      if (merror1.length > 0) {
        let max = read12max
        merror1.sort((a, b) => {
          return a.address - b.address
        })
        let address = merror1.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        addSplit.forEach(arr => {
          let cmd = {f: 1, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          })
          let max
          arr.forEach((sub, index) => {
            const ed = merror1.filter(e => { return e.address === sub })
            errorcode.push({code: start + index + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // errorcode.push({code: start + sub - arr[0] + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // max = start + sub - arr[0] + 1
            max = start + index + 1
          })
          start = max
        })
      }
      if (merror2.length > 0) {
        let max = read12max
        merror2.sort((a, b) => {
          return a.address - b.address
        })
        let address = merror2.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        addSplit.forEach(arr => {
          let cmd = {f: 2, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint16' ? 'uint8' : undefined})
          })
          let max
          arr.forEach((sub, index) => {
            const ed = merror2.filter(e => { return e.address === sub })
            errorcode.push({code: start + index + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // errorcode.push({code: start + sub - arr[0] + 1, errcode: ed[0].errorcode, name: xml.desc, desc: ed[0].desc, desc_en: ed[0].desc_en})
            // max = start + sub - arr[0] + 1
            max = start + index + 1
          })
          start = max
        })
      }
      if (error3.length > 0) {
        let max = read34max
        error3.sort((a, b) => {
          return a.address - b.address
        })
        let address = error3.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        if (errorcode.length > 1) {
          start = 1000
        } else {
          start = 100
        }
        addSplit.forEach(arr => {
          let cmd = {f: 3, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          // 判断故障不连续分割
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          })
          if (modbusjson.prot.errcode.rule != 4 && modbusjson.prot.errcode.rule != 3 && (modbusjson.prot.errcode.rule < 100 || modbusjson.prot.errcode.rule > 199)) {
            let sub = error3.filter(m => { return arr.includes(m.address) })
            let max

            sub.forEach((s, index) => {
              // errorcode.push({code: start + (s.address - arr[0]) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              // max = start + (s.address - arr[0]) * 100 + 15
              errorcode.push({code: start + arr.indexOf(s.address) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              max = start + arr.indexOf(s.address) * 100 + 15
            })
            start = Math.ceil(max / 100) * 100
          }
        })
        if (xml.submax > 1) {
          const addSubSplit = splitArray(address, max, error3, '从')
          addSubSplit.forEach(arr => {
            const ed = error3.filter(e => { return e.address === arr[0] })
            let cmd = {f: 3, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1, o: ed[0].suboffset}
            modbusjson.prot.sub_cmd.push(cmd)
            // modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
            const splitSubError = splitArrayOneByOne(arr)
            splitSubError.forEach(earr => {
              modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.sub_errcode.type == 'uint8' ? 'uint16' : undefined})
            })
          })
        }
      }
      if (error4.length > 0) {
        let max = read34max
        error4.sort((a, b) => {
          return a.address - b.address
        })
        let address = error4.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        if (errorcode.length <= 1) {
          start = 100
        } else {
          if (error3.length == 0) {
            start = 1000
          }
        }
        addSplit.forEach(arr => {
          let cmd = {f: 4, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          // 判断故障不连续分割
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          })
          if (modbusjson.prot.errcode.rule != 4 && modbusjson.prot.errcode.rule != 3 && (modbusjson.prot.errcode.rule < 100 || modbusjson.prot.errcode.rule > 199)) {
            let sub = error4.filter(m => { return arr.includes(m.address) })
            let max

            sub.forEach((s, index) => {
              // errorcode.push({code: start + (s.address - arr[0]) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              // max = start + (s.address - arr[0]) * 100 + 15
              errorcode.push({code: start + arr.indexOf(s.address) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              max = start + arr.indexOf(s.address) * 100 + 15
            })
            start = Math.ceil(max / 100) * 100
          }
        })
        if (xml.submax > 1) {
          const addSubSplit = splitArray(address, max, error4, '从')
          addSubSplit.forEach(arr => {
            const ed = error4.filter(e => { return e.address === arr[0] })
            let cmd = {f: 4, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1, o: ed[0].suboffset}
            modbusjson.prot.sub_cmd.push(cmd)
            // modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
            const splitSubError = splitArrayOneByOne(arr)
            splitSubError.forEach(earr => {
              modbusjson.prot.sub_errcode.list.push({g: modbusjson.prot.sub_cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.sub_errcode.type == 'uint8' ? 'uint16' : undefined})
            })
          })
        }
      }
      if (merror3.length > 0) {
        let max = read34max
        merror3.sort((a, b) => {
          return a.address - b.address
        })
        let address = merror3.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        if (errorcode.length <= 1) {
          start = 100
        } else {
          if (error3.length == 0 && error4.length == 0) {
            start = 1000
          }
        }
        addSplit.forEach(arr => {
          let cmd = {f: 3, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          })
          if (modbusjson.prot.errcode.rule != 4 && modbusjson.prot.errcode.rule != 3 && (modbusjson.prot.errcode.rule < 100 || modbusjson.prot.errcode.rule > 199)) {
            let sub = merror3.filter(m => { return arr.includes(m.address) })
            let max
            sub.forEach((s, index) => {
              // errorcode.push({code: start + (s.address - arr[0]) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              // max = start + (s.address - arr[0]) * 100 + 15
              errorcode.push({code: start + arr.indexOf(s.address) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              max = start + arr.indexOf(s.address) * 100 + 15
            })
            start = Math.ceil(max / 100) * 100
          }
        })
      }
      if (merror4.length > 0) {
        let max = read34max
        merror4.sort((a, b) => {
          return a.address - b.address
        })
        let address = merror4.map(i => { return i.address })
        address = Array.from(new Set(address))
        const addSplit = splitArray(address, max)
        if (errorcode.length <= 1) {
          start = 100
        } else {
          if (error3.length == 0 && error4.length == 0 && merror3.length == 3) {
            start = 1000
          }
        }
        addSplit.forEach(arr => {
          let cmd = {f: 4, s: arr[0], n: arr[arr.length - 1] - arr[0] + 1}
          modbusjson.prot.cmd.push(cmd)
          // modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: 0, n: arr[arr.length - 1] - arr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          const splitError = splitArrayOneByOne(arr)
          splitError.forEach(earr => {
            modbusjson.prot.errcode.list.push({g: modbusjson.prot.cmd.length - 1, s: earr[0] - arr[0], n: earr[earr.length - 1] - earr[0] + 1, t: modbusjson.prot.errcode.type == 'uint8' ? 'uint16' : undefined})
          })

          if (modbusjson.prot.errcode.rule != 4 && modbusjson.prot.errcode.rule != 3 && (modbusjson.prot.errcode.rule < 100 || modbusjson.prot.errcode.rule > 199)) {
            let sub = merror4.filter(m => { return arr.includes(m.address) })
            let max
            sub.forEach((s, index) => {
              // errorcode.push({code: start + (s.address - arr[0]) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              // max = start + (s.address - arr[0]) * 100 + 15
              errorcode.push({code: start + arr.indexOf(s.address) * 100 + s.bit, errcode: s.errorcode, name: xml.desc, desc: s.desc, desc_en: s.desc_en})
              max = start + arr.indexOf(s.address) * 100 + 15
            })
            start = Math.ceil(max / 100) * 100
          }
        })
      }
    }
  }

  if (table.length !== 6) {
    return '模板不正确，请勿更改模板'
  }
  if (table.length >= 8) {
    // 模块机
    xml.topology = 'MS'
    modbusjson.prot.Topology = 'MS'
  }

  table.forEach((sheet, index) => {
    sheet.styles = [{ bgcolor: '#fe0000' }]
    allRow = []
    if (sheet.name === '基础信息') {
      // 基本信息表
      for (let key in sheet.rows) {
        if (key == 'len' || !sheet.rows[key].cells['0'] || !sheet.rows[key].cells['0'].text) {
          continue
        }
        if (sheet.rows[key].cells['1']) {
          delete sheet.rows[key].cells['1'].style
        }

        // 必填验证码
        if (!isNaN(key) && sheet.rows[key].cells['0'] && sheet.rows[key].cells['0'].text != '协议名称翻译' && sheet.rows[key].cells['0'].text != '从设备名称' && sheet.rows[key].cells['0'].text != '设备名称翻译' && sheet.rows[key].cells['0'].text != '从设备名称翻译' && sheet.rows[key].cells['0'].text != '默认项目名称翻译' && sheet.rows[key].cells['0'].text != '主模块屏蔽故障代码' && sheet.rows[key].cells['0'].text != '从模块屏蔽故障代码' && (!sheet.rows[key].cells['1'] || !sheet.rows[key].cells['1'].text)) {
          if (sheet.rows[key].cells['1']) {
            sheet.rows[key].cells['1'].style = 0
          } else {
            sheet.rows[key].cells['1'] = {style: 0}
          }
          pass = false
          continue
        }
        let title = sheet.rows[key].cells['0'].text
        // 单项范围验证
        if (title === '协议名称') {
          xml.desc = sheet.rows[key].cells['1'].text
          modbusjson.prot.desc = sheet.rows[key].cells['1'].text
        } else if (title === '协议名称翻译' && sheet.rows[key].cells['1'] && sheet.rows[key].cells['1'].text) {
          xml.desc_en = sheet.rows[key].cells['1'].text
        } else if (title === '默认项目名称') {
          mibeejson.Name = sheet.rows[key].cells['1'].text
        } else if (title === 'modbus地址' || title === '第2路485从站地址') {
          checkRange(sheet.rows[key].cells['1'], 0, 255)
          if (title === 'modbus地址') {
            phyaddr = parseInt(sheet.rows[key].cells['1'].text)
          } else if (title === '第2路485从站地址') {
            uart2.slaveid = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '波特率' || title === '第2路485从站波特率') {
          const arry = ['600', '1200', '2400', '3600', '4800', '7200', '9600', '14400', '19200', '28800', '38400', '57600', '115200']
          if (checkArray(sheet.rows[key].cells['1'], arry)) {
            if (title === '波特率') {
              uart1.baud = sheet.rows[key].cells['1'].text
            } else {
              uart2.baud = sheet.rows[key].cells['1'].text
            }
          }
        } else if (title === '奇偶校验' || title === '第2路485从站奇偶校验') {
          // 奇偶校验 N,E,O
          const arry = ['N', 'E', 'O']
          if (checkArray(sheet.rows[key].cells['1'], arry)) {
            if (title === '奇偶校验') {
              uart1.parity = sheet.rows[key].cells['1'].text
            } else {
              uart2.parity = sheet.rows[key].cells['1'].text
            }
          }
        } else if (title === '停止位' || title === '第2路485从站停止位') {
          // 停止位 1,2
          const arry = ['1', '2']
          if (checkArray(sheet.rows[key].cells['1'], arry)) {
            if (title === '停止位') {
              uart1.stop = sheet.rows[key].cells['1'].text
            } else {
              uart2.stop = sheet.rows[key].cells['1'].text
            }
          }
        } else if (title === '写线圈用15命令' || title === '写保持用16命令' || title === '第2路485作为从站使用' || title === '地址-1使用') {
          const arry = ['是', '否']
          if (checkArray(sheet.rows[key].cells['1'], arry) && sheet.rows[key].cells['1'].text === '是') {
            if (title === '第2路485作为从站使用') {
              uart2.mode = 'slave'
            } else if (title === '写线圈用15命令') {
              modbusjson.prot.writecoil = 15
            } else if (title === '写保持用16命令') {
              modbusjson.prot.writehold = 16
            } else if (title === '地址-1使用') {
              needsub1 = true
            }
          }
        } else if (title === '第2路485从站工作模式') {
          const arry = ['1', '2']
          if (checkArray(sheet.rows[key].cells['1'], arry)) {
            uart2.slavemd = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '读超时时间(毫秒)' || title === '写超时时间(毫秒)') {
          if (checkRange(sheet.rows[key].cells['1'], 100, 60000)) {
            if (title === '读超时时间(毫秒)') {
              modbusjson.prot.readtimeout = parseInt(sheet.rows[key].cells['1'].text)
            } else if (title === '写超时时间(毫秒)') {
              modbusjson.prot.writetimeout = parseInt(sheet.rows[key].cells['1'].text)
            }
          }
        } else if (title === '两次轮询间隔(秒)') {
          if (checkRange(sheet.rows[key].cells['1'], 0, 60)) {
            modbusjson.prot.readcycle = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '写后停止读时间(秒)') {
          if (checkRange(sheet.rows[key].cells['1'], 0, 120)) {
            modbusjson.prot.writestopread = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === 'OTA升级协议选择') {
          if (checkRange(sheet.rows[key].cells['1'], 0, 99)) {
            modbusjson.prot.otaprotocol = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '485方向切换延迟(微秒)') {
          if (checkRange(sheet.rows[key].cells['1'], 100, 20000)) {
            modbusjson.prot.dir485time = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '线圈离散寄存器单次最大读取数量') {
          if (checkRange(sheet.rows[key].cells['1'], 16, 1024)) {
            read12max = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '保持输入寄存器单次最大读取数量') {
          if (checkRange(sheet.rows[key].cells['1'], 1, 120)) {
            read34max = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '故障代码处理规则') {
          let arry = ['1', '2', '3', '4', '7']
          for (let i = 100; i <= 199; i++) {
            arry.push(i.toString())
          }
          if (checkArray(sheet.rows[key].cells['1'], arry)) {
            modbusjson.prot.errcode.rule = parseInt(sheet.rows[key].cells['1'].text)
            modbusjson.prot.sub_errcode.rule = parseInt(sheet.rows[key].cells['1'].text)
          }
        } else if (title === '主从机最大数量') {
          if (checkRange(sheet.rows[key].cells['1'], 1, 128)) {
            xml.submax = parseInt(sheet.rows[key].cells['1'].text)
            modbusjson.prot.submax = xml.submax
            if (xml.submax > 1) {
              xml.topology = 'MS'
              modbusjson.prot.Topology = 'MS'
            } else {
              delete modbusjson.prot.sub_stopread
            }
          }
        } else if (title === '无效从机处理规则') {
          if (xml.submax > 1 && checkRange(sheet.rows[key].cells['1'], 0, 5)) {
            let rule = parseInt(sheet.rows[key].cells['1'].text)
            if (rule) {
              modbusjson.prot.sub_stopread.rule = rule
              if (rule < 4) {
                modbusjson.prot.sub_stopread.type = 'uint16'
              }
            } else {
              delete modbusjson.prot.sub_stopread
            }
          }
        } else if (title === '设备名称' && sheet.rows[key].cells['1'].text) {
          mainDevice = sheet.rows[key].cells['1'].text
        } else if (title === '从设备名称' && sheet.rows[key].cells['1'].text) {
          subDevice = sheet.rows[key].cells['1'].text
        } else if (title === '协议专属标志' && sheet.rows[key].cells['1'].text) {
          modbusjson.prot.protflag = sheet.rows[key].cells['1'].text
        } else if (title === '设备功能' && sheet.rows[key].cells['1'].text) {
          if (sheet.rows[key].cells['1'].text == '空调') {
            xml.function = 'aricondition'
            xml.functionname = '空调'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Name = '空调'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Type = 'aricondition'
          } else if (sheet.rows[key].cells['1'].text == '空开') {
            xml.function = 'acb'
            xml.functionname = '空开'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Name = '空开'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Type = 'acb'
          } else if (sheet.rows[key].cells['1'].text == '新风') {
            xml.function = 'freshair'
            xml.functionname = '新风'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Name = '新风'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Type = 'freshair'
          } else if (sheet.rows[key].cells['1'].text == '锅炉') {
            xml.function = 'boiler'
            xml.functionname = '锅炉'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Name = '锅炉'
            mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Type = 'boiler'
          }
        } else if (title === '主模块屏蔽故障代码' && sheet.rows[key].cells['1'].text) {
          try {
            modbusjson.prot.errcode.blockcodes = sheet.rows[key].cells['1'].text.split(',').map(i => { return parseInt(i) })
          } catch (e) {
            console.log(e)
          }
        } else if (title === '从模块屏蔽故障代码' && sheet.rows[key].cells['1'].text) {
          try {
            modbusjson.prot.sub_errcode.blockcodes = sheet.rows[key].cells['1'].text.split(',').map(i => { return parseInt(i) })
          } catch (e) {
            console.log(e)
          }
        } else if (title === '两路端口功能对调' && sheet.rows[key].cells['1'] && sheet.rows[key].cells['1'].text) {
          const arry = ['是', '否']
          if (checkArray(sheet.rows[key].cells['1'], arry) && sheet.rows[key].cells['1'].text === '是') {
            modbusjson.portswap = 'y'
          }
        }
      }

      // mibeeJson 插入设备
      mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Devices = []
      for (let i = 0; i < xml.submax; i++) {
        let deviceid = 17563905 + i
        let dev = {AddSource: 'pms', Brand: '', ClassName: xml.desc, DeviceID: deviceid.toString(), ID: deviceid, IsSecurityDev: 'no', Model: '', Name: i == 0 ? mainDevice : (subDevice + i), ProtocolId: 0, functionname: mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Name, functiontype: mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Type, subdevs: i + 1, type: 'modbus'}
        mibeejson.Building[0].Floors[0].Rooms[0].Functions[0].Devices.push(dev)
        modbusjson.dev.push({id: deviceid, subdevs: i + 1, phyaddr: phyaddr})
      }
    } else if (sheet.name === '03码保持寄存器4x') {
      // 获取第一行标签
      let head = sheet.rows['0'].cells
      modbusList = []
      for (let key in sheet.rows) {
        if (key === 'len' || key === '0') {
          continue
        }
        let dp = {dpid: 0, name: '', desc: '', text: [], values: [], type: 2, linkagetype: 'none', max: 100000, min: -100000, step: 1, unit: null, xrw: 3, desc_en: null, text_en: [], groupname: '', subhide: 0, healthmin: null, healthmax: null}
        let modbus = {f: 3, aif: 0, dp: 0, wad: -1, wfc: 0, typ: 0, wbit: 0, bit: null, mul: 1, ofs: 0, ech: 1, ts: 0, rs: 0, ftv: 0, wr: 1, address: '', suboffset: 0, sub: '主从', map: 0}
        for (let ckey in sheet.rows[key].cells) {
          delete sheet.rows[key].cells[ckey].style

          if (head[ckey].text === 'APP标签') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.name }))) {
                if (xml.submax > 1 && sheet.rows[key].cells[ckey].text == 'slavenum' && modbusjson.prot.sub_stopread && modbusjson.prot.sub_stopread.rule == 5) {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }
                dp.name = sheet.rows[key].cells[ckey].text
              }
            }
          } else if (head[ckey].text === '数据编号') {
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkRange(sheet.rows[key].cells[ckey], 1, 8000) && checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.dpid + '' }))) {
              dp.dpid = parseInt(sheet.rows[key].cells[ckey].text)
              modbus.dp = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '允许定时控制') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              dp.linkagetype = 'action'
            }
          } else if (head[ckey].text === '参数分组') {
            if (sheet.rows[key].cells[ckey].text) {
              dp.groupname = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '协议地址') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              let value = sheet.rows[key].cells[ckey].text.split('.')
              if (value.length === 1 || value.length === 2) {
                if (value[0] && !isNaN(value[0]) && value[0] >= 0 && value[0] <= 65535) {
                  modbus.address = parseInt(value[0]) - (needsub1 ? 1 : 0)
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }

                if (value.length === 1) {
                  modbus.bit = null
                } else {
                  // 验证小数点后
                  try {
                    let value2 = JSON.parse(value[1])
                    modbus.typ = 8
                    if (value2.constructor.name === 'Number') {
                      if (value2 >= 0 && value2 <= 15) {
                        modbus.bit = value2
                      } else {
                        sheet.rows[key].cells[ckey].style = 0
                        pass = false
                      }
                    } else if (value2.constructor.name === 'Array') {
                      if (value2.length === 2 || value2.length === 4) {
                        let check = true
                        value2.forEach((i, index) => {
                          if (i.constructor.name !== 'Number' || i < 0 || i > 15) {
                            check = false
                          }
                          if (index) {
                            if (i >= value2[index - 1]) {
                              check = false
                            }
                          }
                        })
                        if (check) {
                          modbus.bit = value2
                        } else {
                          sheet.rows[key].cells[ckey].style = 0
                          pass = false
                        }
                      } else {
                        sheet.rows[key].cells[ckey].style = 0
                        pass = false
                      }
                    } else {
                      sheet.rows[key].cells[ckey].style = 0
                      pass = false
                    }
                  } catch (e) {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '参数名称') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              dp.desc = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '参数名翻译') {
            dp.desc_en = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '读写权限') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              if (sheet.rows[key].cells[ckey].text === '只写不读') {
                dp.xrw = 1
                modbus.wr = 1
                modbus.f = 6
              } else if ((sheet.rows[key].cells[ckey].text.indexOf('读') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('R') >= 0) && (sheet.rows[key].cells[ckey].text.indexOf('写') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('W') >= 0)) {
                dp.xrw = 3
                modbus.wr = 1
              } else if (sheet.rows[key].cells[ckey].text.indexOf('读') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('R') >= 0) {
                dp.xrw = 2
                modbus.wr = 0
              } else if (sheet.rows[key].cells[ckey].text.indexOf('写') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('W') >= 0) {
                dp.xrw = 1
                modbus.wr = 1
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '数据类型') {
            if (checkRange(sheet.rows[key].cells[ckey], 0, 1000)) {
              let typ = parseInt(sheet.rows[key].cells[ckey].text)
              if ((modbus.bit != null && ![8, 22, 23].includes(typ)) || (modbus.bit == null && [8, 22, 23].includes(typ))) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                modbus.typ = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '单位') {
            dp.unit = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '最小值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.min = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.min = -100000
            }
          } else if (head[ckey].text === '最大值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.max = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.max = 100000
            }
          } else if (head[ckey].text === '枚举列表') {
            if (sheet.rows[key].cells[ckey].text) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[-:=：][^\,\，\;\；\s]+/g)
              if (!vArry || vArry.length == 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                dp.type = 1
                dp.max = null
                dp.min = null
                vArry.forEach(item => {
                  let d = item.split(/[-:=：]/)
                  if (d.length === 2) {
                    dp.values.push(parseInt(d[0]))
                    dp.text.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '枚举翻译') {
            if (sheet.rows[key].cells[ckey].text) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[-:=：][^\,\，\;\；]+/g)
              if (!vArry || vArry.length === 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                vArry.forEach(item => {
                  let d = item.split(/[-:=：]/)
                  if (d.length === 2) {
                    dp.text_en.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '倍率') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkInt(sheet.rows[key].cells[ckey])) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                if ((v >= -10000 && v <= -1) || (v >= 1 && v <= 10000)) {
                  if (v <= 1) {
                    dp.step = 1
                  } else {
                    dp.step = Math.round(1 / v * 1000) / 1000
                  }
                  modbus.mul = v
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              }
            }
          } else if (head[ckey].text === '偏移量') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -10000, 10000)) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                modbus.ofs = v
              }
            }
          } else if (head[ckey].text === '上报灵敏度') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                if (v >= 0.001 && v <= 1000) {
                  modbus.ech = Math.round(v * 1000) / 1000
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '实时上报') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              modbus.rs = 1
            }
          } else if (head[ckey].text === '每分钟定时上报') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.ts = 1
            }
          } else if (head[ckey].text === '步进') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                if (v >= 0.001 && v <= 1000) {
                  dp.step = Math.round(v * 1000) / 1000
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '特殊写地址') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 65535)) {
                modbus.wad = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '特殊写功能码') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['5', '6', '15', '16']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.wfc = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '允许读失败') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.aif = 1
            }
          } else if (head[ckey].text === '异常代码') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -32768, 65535)) {
                modbus.ftv = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'wbit') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 14)) {
                modbus.wbit = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '主从属性') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['主', '从', '主从']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.sub = sheet.rows[key].cells[ckey].text
                if (sheet.rows[key].cells[ckey].text == '主') {
                  dp.subhide = 1
                } else if (sheet.rows[key].cells[ckey].text == '从') {
                  dp.subhide = 2
                }
              }
            }
          } else if (head[ckey].text === '地址偏移') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 20000)) {
                modbus.suboffset = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'map') {
            if (sheet.rows[key].cells[ckey].text) {
              try {
                let value = JSON.parse(sheet.rows[key].cells[ckey].text)
                if (value.constructor.name === 'Array') {
                  if (value.length > 0 && value.length <= 128 && value.length % 2 === 0) {
                    modbus.map = value
                  } else {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } catch (e) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '健康最小值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                dp.healthmin = Math.round(v * 1000) / 1000
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '健康最大值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                dp.healthmax = Math.round(v * 1000) / 1000
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          }
        }
        if (!dp.name) {
          dp.name = 't' + dp.dpid
        }
        if (dp.name === 'power') {
          modbusjson.prot.powerdpid = dp.dpid
        } else if (dp.name === 'softver') {
          modbusjson.prot.softverdpid = dp.dpid
        } else if (dp.name === 'slavenum') {
          slavenum = dp.dpid
        } else if (dp.name === 'modelnum') {
          modelnum = dp.dpid
        } else if (dp.name === 'subvld_1') {
          subvld_1 = dp.dpid
        }
        if (dp.values.length > 0) {
          dp.values = JSON.stringify(dp.values)
        } else {
          dp.values = null
        }
        if (dp.text.length > 0) {
          dp.text = JSON.stringify(dp.text)
        } else {
          dp.text = null
        }
        if (dp.text_en.length > 0) {
          dp.text_en = JSON.stringify(dp.text_en)
        } else {
          dp.text_en = null
        }
        if (dp.dpid && (modbus.address || modbus.address == 0) && dp.desc) {
          xml.dp.push(dp)
          modbusList.push(modbus)
        }
      }
      allRow.concat(modbusList)
      buildCmd(3)
      if (xml.submax > 1) {
        buildCmd(3, '从')
      }
      buildCmd(6)
      if (xml.submax > 1) {
        buildCmd(6, '从')
      }
    } else if (sheet.name === '04码输入寄存器3x') {
      let head = sheet.rows['0'].cells
      modbusList = []
      for (let key in sheet.rows) {
        if (key === 'len' || key === '0') {
          continue
        }
        let dp = {dpid: 0, name: '', desc: '', text: [], values: [], type: 2, linkagetype: 'none', max: 100000, min: -100000, step: 1, unit: null, xrw: 2, desc_en: null, text_en: [], groupname: '', subhide: 0, healthmin: null, healthmax: null}
        let modbus = {f: 4, aif: 0, dp: 0, wad: -1, wfc: 0, typ: 0, wbit: 0, bit: null, mul: 1, ofs: 0, ech: 1, ts: 0, rs: 0, ftv: 0, wr: 0, address: '', suboffset: 0, sub: '主从', map: 0}
        for (let ckey in sheet.rows[key].cells) {
          delete sheet.rows[key].cells[ckey].style

          if (head[ckey].text === 'APP标签') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.name }))) {
                if (xml.submax > 1 && sheet.rows[key].cells[ckey].text == 'slavenum' && modbusjson.prot.sub_stopread && modbusjson.prot.sub_stopread.rule == 5) {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }
                dp.name = sheet.rows[key].cells[ckey].text
              }
            }
          } else if (head[ckey].text === '数据编号') {
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkRange(sheet.rows[key].cells[ckey], 1, 8000) && checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.dpid + '' }))) {
              dp.dpid = parseInt(sheet.rows[key].cells[ckey].text)
              modbus.dp = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '允许定时控制') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              dp.linkagetype = 'action'
            }
          } else if (head[ckey].text === '参数分组') {
            if (sheet.rows[key].cells[ckey].text) {
              dp.groupname = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '协议地址') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              let value = sheet.rows[key].cells[ckey].text.split('.')
              if (value.length === 1 || value.length === 2) {
                if (value[0] && !isNaN(value[0]) && value[0] >= 0 && value[0] <= 65535) {
                  modbus.address = parseInt(value[0]) - (needsub1 ? 1 : 0)
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }

                if (value.length === 1) {
                  modbus.bit = null
                } else {
                  // 验证小数点后
                  try {
                    let value2 = JSON.parse(value[1])
                    modbus.typ = 8
                    if (value2.constructor.name === 'Number') {
                      if (value2 >= 0 && value2 <= 15) {
                        modbus.bit = value2
                      } else {
                        sheet.rows[key].cells[ckey].style = 0
                        pass = false
                      }
                    } else if (value2.constructor.name === 'Array') {
                      if (value2.length === 2 || value2.length === 4) {
                        let check = true
                        value2.forEach((i, index) => {
                          if (i.constructor.name !== 'Number' || i < 0 || i > 15) {
                            check = false
                          }
                          if (index) {
                            if (i >= value2[index - 1]) {
                              check = false
                            }
                          }
                        })
                        if (check) {
                          modbus.bit = value2
                        } else {
                          sheet.rows[key].cells[ckey].style = 0
                          pass = false
                        }
                      } else {
                        sheet.rows[key].cells[ckey].style = 0
                        pass = false
                      }
                    } else {
                      sheet.rows[key].cells[ckey].style = 0
                      pass = false
                    }
                  } catch (e) {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '参数名称') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              dp.desc = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '参数名翻译') {
            dp.desc_en = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '读写权限') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              if (sheet.rows[key].cells[ckey].text.indexOf('读') >= 0 && sheet.rows[key].cells[ckey].text.indexOf('写') >= 0) {
                dp.xrw = 3
                modbus.wr = 1
              } else if (sheet.rows[key].cells[ckey].text.indexOf('读') >= 0) {
                dp.xrw = 2
                modbus.wr = 0
              } else if (sheet.rows[key].cells[ckey].text.indexOf('写') >= 0) {
                dp.xrw = 1
                modbus.wr = 1
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '数据类型') {
            if (checkRange(sheet.rows[key].cells[ckey], 0, 1000)) {
              let typ = parseInt(sheet.rows[key].cells[ckey].text)
              if ((modbus.bit != null && ![8, 22, 23].includes(typ)) || (modbus.bit == null && [8, 22, 23].includes(typ))) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                modbus.typ = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '单位') {
            dp.unit = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '最小值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.min = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.min = -100000
            }
          } else if (head[ckey].text === '最大值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.max = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.max = 100000
            }
          } else if (head[ckey].text === '枚举列表') {
            if (sheet.rows[key].cells[ckey].text) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[-:=：][^\,\，\;\；\s]+/g)
              if (!vArry || vArry.length == 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                dp.type = 1
                dp.max = null
                dp.min = null
                vArry.forEach(item => {
                  let d = item.split(/[-:=：]/)
                  if (d.length === 2) {
                    dp.values.push(parseInt(d[0]))
                    dp.text.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '枚举翻译') {
            if (sheet.rows[key].cells[ckey].text) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[-:=：][^\,\，\;\；]+/g)
              if (!vArry || vArry.length === 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                vArry.forEach(item => {
                  let d = item.split(/[-:=：]/)
                  if (d.length === 2) {
                    dp.text_en.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '倍率') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkInt(sheet.rows[key].cells[ckey])) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                if ((v >= -10000 && v <= -1) || (v >= 1 && v <= 10000)) {
                  if (v <= 1) {
                    dp.step = 1
                  } else {
                    dp.step = Math.round(1 / v * 1000) / 1000
                  }
                  modbus.mul = v
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              }
            }
          } else if (head[ckey].text === '偏移量') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -10000, 10000)) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                modbus.ofs = v
              }
            }
          } else if (head[ckey].text === '上报灵敏度') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                if (v >= 0.001 && v <= 1000) {
                  modbus.ech = Math.round(v * 1000) / 1000
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '实时上报') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              modbus.rs = 1
            }
          } else if (head[ckey].text === '每分钟定时上报') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.ts = 1
            }
          } else if (head[ckey].text === '步进') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                if (v >= 0.001 && v <= 1000) {
                  dp.step = Math.round(v * 1000) / 1000
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '特殊写地址') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 65535)) {
                modbus.wad = parseInt(sheet.rows[key].cells[ckey].text)
                modbus.wr = 1
                dp.xrw = 3
              }
            }
          } else if (head[ckey].text === '特殊写功能码') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['5', '6', '15', '16']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.wfc = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '允许读失败') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.aif = 1
            }
          } else if (head[ckey].text === '异常代码') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -32768, 65535)) {
                modbus.ftv = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'wbit') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 14)) {
                modbus.wbit = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '主从属性') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['主', '从', '主从']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.sub = sheet.rows[key].cells[ckey].text
                if (sheet.rows[key].cells[ckey].text == '主') {
                  dp.subhide = 1
                } else if (sheet.rows[key].cells[ckey].text == '从') {
                  dp.subhide = 2
                }
              }
            }
          } else if (head[ckey].text === '地址偏移') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 20000)) {
                modbus.suboffset = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'map') {
            if (sheet.rows[key].cells[ckey].text) {
              try {
                let value = JSON.parse(sheet.rows[key].cells[ckey].text)
                if (value.constructor.name === 'Array') {
                  if (value.length > 0 && value.length <= 128 && value.length % 2 === 0) {
                    modbus.map = value
                  } else {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } catch (e) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '健康最小值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                dp.healthmin = Math.round(v * 1000) / 1000
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '健康最大值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                dp.healthmax = Math.round(v * 1000) / 1000
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          }
        }
        if (!dp.name) {
          dp.name = 't' + dp.dpid
        }
        if (dp.name === 'power') {
          modbusjson.prot.powerdpid = dp.dpid
        } else if (dp.name === 'softver') {
          modbusjson.prot.softverdpid = dp.dpid
        } else if (dp.name === 'slavenum') {
          slavenum = dp.dpid
        } else if (dp.name === 'modelnum') {
          modelnum = dp.dpid
        } else if (dp.name === 'subvld_1') {
          subvld_1 = dp.dpid
        }
        if (dp.values.length > 0) {
          dp.values = JSON.stringify(dp.values)
        } else {
          dp.values = null
        }
        if (dp.text.length > 0) {
          dp.text = JSON.stringify(dp.text)
        } else {
          dp.text = null
        }
        if (dp.text_en.length > 0) {
          dp.text_en = JSON.stringify(dp.text_en)
        } else {
          dp.text_en = null
        }
        if (dp.dpid && (modbus.address || modbus.address == 0) && dp.desc) {
          xml.dp.push(dp)
          modbusList.push(modbus)
        }
      }
      allRow.concat(modbusList)
      buildCmd(4)
      if (xml.submax > 1) {
        buildCmd(4, '从')
      }
    } else if (sheet.name === '01码线圈寄存器0x') {
      let head = sheet.rows['0'].cells
      modbusList = []
      for (let key in sheet.rows) {
        if (key === 'len' || key === '0') {
          continue
        }
        let dp = {dpid: 0, name: '', desc: '', text: ['0', '1'], values: [0, 1], type: 1, linkagetype: 'none', max: 100000, min: -100000, step: 1, unit: null, xrw: 3, desc_en: null, text_en: [], groupname: '', subhide: 0, healthmin: null, healthmax: null}
        let modbus = {f: 1, aif: 0, dp: 0, wad: -1, wfc: 0, typ: 0, wbit: 0, bit: null, mul: 1, ofs: 0, ech: 1, ts: 0, rs: 0, ftv: 0, wr: 1, address: '', suboffset: 0, sub: '主从', map: 0}
        for (let ckey in sheet.rows[key].cells) {
          delete sheet.rows[key].cells[ckey].style

          if (head[ckey].text === 'APP标签') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.name }))) {
                if (xml.submax > 1 && sheet.rows[key].cells[ckey].text == 'slavenum' && modbusjson.prot.sub_stopread && modbusjson.prot.sub_stopread.rule == 5) {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }
                dp.name = sheet.rows[key].cells[ckey].text
              }
            }
          } else if (head[ckey].text === '数据编号') {
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkRange(sheet.rows[key].cells[ckey], 1, 8000) && checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.dpid + '' }))) {
              dp.dpid = parseInt(sheet.rows[key].cells[ckey].text)
              modbus.dp = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '允许定时控制') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              dp.linkagetype = 'action'
            }
          } else if (head[ckey].text === '参数分组') {
            if (sheet.rows[key].cells[ckey].text) {
              dp.groupname = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '协议地址') {
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkRange(sheet.rows[key].cells[ckey], 0, 65535)) {
              modbus.address = parseInt(sheet.rows[key].cells[ckey].text) - (needsub1 ? 1 : 0)
            }
          } else if (head[ckey].text === '参数名称') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              dp.desc = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '参数名翻译') {
            dp.desc_en = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '读写权限') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              if (sheet.rows[key].cells[ckey].text === '只写不读') {
                dp.xrw = 1
                modbus.wr = 1
                modbus.f = 5
              } else if ((sheet.rows[key].cells[ckey].text.indexOf('读') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('R') >= 0) && (sheet.rows[key].cells[ckey].text.indexOf('写') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('W') >= 0)) {
                dp.xrw = 3
                modbus.wr = 1
              } else if (sheet.rows[key].cells[ckey].text.indexOf('读') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('R') >= 0) {
                dp.xrw = 2
                modbus.wr = 0
              } else if (sheet.rows[key].cells[ckey].text.indexOf('写') >= 0 || sheet.rows[key].cells[ckey].text.toUpperCase().indexOf('W') >= 0) {
                dp.xrw = 1
                modbus.wr = 1
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '数据类型') {
            if (checkRange(sheet.rows[key].cells[ckey], 0, 1000)) {
              modbus.typ = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '单位') {
            dp.unit = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '最小值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.min = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.min = -100000
            }
          } else if (head[ckey].text === '最大值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.max = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.max = 100000
            }
          } else if (head[ckey].text === '枚举列表') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[-:=：][^\,\，\;\；\s]+/g)
              if (!vArry || vArry.length == 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                dp.type = 1
                dp.max = null
                dp.min = null
                dp.values = []
                dp.text = []
                vArry.forEach(item => {
                  let d = item.split(/[-:=：]/)
                  if (d.length === 2) {
                    dp.values.push(parseInt(d[0]))
                    dp.text.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '枚举翻译') {
            if (sheet.rows[key].cells[ckey].text) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[:=：][^\,\，\;\；]+/g)
              if (!vArry || vArry.length === 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                vArry.forEach(item => {
                  let d = item.split(/[:=：]/)
                  if (d.length === 2) {
                    dp.text_en.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '倍率') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkInt(sheet.rows[key].cells[ckey])) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                if ((v >= -10000 && v <= -1) || (v >= 1 && v <= 10000)) {
                  if (v <= 1) {
                    dp.step = 1
                  } else {
                    dp.step = Math.round(1 / v * 1000) / 1000
                  }
                  modbus.mul = v
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              }
            }
          } else if (head[ckey].text === '偏移量') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -10000, 10000)) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                modbus.ofs = v
              }
            }
          } else if (head[ckey].text === '上报灵敏度') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                if (v >= 0.001 && v <= 1000) {
                  modbus.ech = Math.round(v * 1000) / 1000
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '实时上报') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              modbus.rs = 1
            }
          } else if (head[ckey].text === '每分钟定时上报') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.ts = 1
            }
          } else if (head[ckey].text === '特殊写地址') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 65535)) {
                modbus.wad = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '特殊写功能码') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['5', '6', '15', '16']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.wfc = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '允许读失败') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.aif = 1
            }
          } else if (head[ckey].text === '异常代码') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -32768, 65535)) {
                modbus.ftv = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'wbit') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 14)) {
                modbus.wbit = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '主从属性') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['主', '从', '主从']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.sub = sheet.rows[key].cells[ckey].text
                if (sheet.rows[key].cells[ckey].text == '主') {
                  dp.subhide = 1
                } else if (sheet.rows[key].cells[ckey].text == '从') {
                  dp.subhide = 2
                }
              }
            }
          } else if (head[ckey].text === '地址偏移') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 20000)) {
                modbus.suboffset = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'map') {
            if (sheet.rows[key].cells[ckey].text) {
              try {
                let value = JSON.parse(sheet.rows[key].cells[ckey].text)
                if (value.constructor.name === 'Array') {
                  if (value.length > 0 && value.length <= 128 && value.length % 2 === 0) {
                    modbus.map = value
                  } else {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } catch (e) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          }
        }
        if (!dp.name) {
          dp.name = 't' + dp.dpid
        }
        if (dp.name === 'power') {
          modbusjson.prot.powerdpid = dp.dpid
        } else if (dp.name === 'softver') {
          modbusjson.prot.softverdpid = dp.dpid
        } else if (dp.name === 'slavenum') {
          slavenum = dp.dpid
        } else if (dp.name === 'modelnum') {
          modelnum = dp.dpid
        } else if (dp.name === 'subvld_1') {
          subvld_1 = dp.dpid
        }
        if (dp.values.length > 0) {
          dp.values = JSON.stringify(dp.values)
        } else {
          dp.values = null
        }
        if (dp.text.length > 0) {
          dp.text = JSON.stringify(dp.text)
        } else {
          dp.text = null
        }
        if (dp.text_en.length > 0) {
          dp.text_en = JSON.stringify(dp.text_en)
        } else {
          dp.text_en = null
        }
        if (dp.dpid && (modbus.address || modbus.address == 0) && dp.desc) {
          xml.dp.push(dp)
          modbusList.push(modbus)
        }
      }
      allRow.concat(modbusList)
      buildCmd(1)
      if (xml.submax > 1) {
        buildCmd(1, '从')
      }
      buildCmd(5)
      if (xml.submax > 1) {
        buildCmd(5, '从')
      }
    } else if (sheet.name === '02码离散输入寄存器1x') {
      let head = sheet.rows['0'].cells
      modbusList = []
      for (let key in sheet.rows) {
        if (key === 'len' || key === '0') {
          continue
        }
        let dp = {dpid: 0, name: '', desc: '', text: ['0', '1'], values: [0, 1], type: 1, linkagetype: 'none', max: 100000, min: -100000, step: 1, unit: null, xrw: 2, desc_en: null, text_en: [], groupname: '', subhide: 0, healthmin: null, healthmax: null}
        let modbus = {f: 2, aif: 0, dp: 0, wad: -1, wfc: 0, typ: 0, wbit: 0, bit: null, mul: 1, ofs: 0, ech: 1, ts: 0, rs: 0, ftv: 0, wr: 0, address: '', suboffset: 0, sub: '主从', map: 0}
        for (let ckey in sheet.rows[key].cells) {
          delete sheet.rows[key].cells[ckey].style

          if (head[ckey].text === 'APP标签') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.name }))) {
                if (xml.submax > 1 && sheet.rows[key].cells[ckey].text == 'slavenum' && modbusjson.prot.sub_stopread && modbusjson.prot.sub_stopread.rule == 5) {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }
                dp.name = sheet.rows[key].cells[ckey].text
              }
            }
          } else if (head[ckey].text === '数据编号') {
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkRange(sheet.rows[key].cells[ckey], 1, 8000) && checkDuplicate(sheet.rows[key].cells[ckey], xml.dp.map(d => { return d.dpid + '' }))) {
              dp.dpid = parseInt(sheet.rows[key].cells[ckey].text)
              modbus.dp = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '允许定时控制') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              dp.linkagetype = 'action'
            }
          } else if (head[ckey].text === '参数分组') {
            if (sheet.rows[key].cells[ckey].text) {
              dp.groupname = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '协议地址') {
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkRange(sheet.rows[key].cells[ckey], 0, 65535)) {
              modbus.address = parseInt(sheet.rows[key].cells[ckey].text) - (needsub1 ? 1 : 0)
            }
          } else if (head[ckey].text === '参数名称') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              dp.desc = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '参数名翻译') {
            dp.desc_en = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '读写权限') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              if (sheet.rows[key].cells[ckey].text.indexOf('读') >= 0 && sheet.rows[key].cells[ckey].text.indexOf('写') >= 0) {
                dp.xrw = 3
                modbus.wr = 1
              } else if (sheet.rows[key].cells[ckey].text.indexOf('读') >= 0) {
                dp.xrw = 2
                modbus.wr = 0
              } else if (sheet.rows[key].cells[ckey].text.indexOf('写') >= 0) {
                dp.xrw = 1
                modbus.wr = 1
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '数据类型') {
            if (checkRange(sheet.rows[key].cells[ckey], 0, 1000)) {
              modbus.typ = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '单位') {
            dp.unit = sheet.rows[key].cells[ckey].text
          } else if (head[ckey].text === '最小值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.min = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.min = -100000
            }
          } else if (head[ckey].text === '最大值') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkNumber(sheet.rows[key].cells[ckey])) {
                dp.max = parseInt(sheet.rows[key].cells[ckey].text)
              }
            } else {
              dp.max = 100000
            }
          } else if (head[ckey].text === '枚举列表') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[-:=：][^\,\，\;\；\s]+/g)
              if (!vArry || vArry.length == 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                dp.type = 1
                dp.max = null
                dp.min = null
                dp.values = []
                dp.text = []
                vArry.forEach(item => {
                  let d = item.split(/[-:=：]/)
                  if (d.length === 2) {
                    dp.values.push(parseInt(d[0]))
                    dp.text.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '枚举翻译') {
            if (sheet.rows[key].cells[ckey].text) {
              sheet.rows[key].cells[ckey].text = sheet.rows[key].cells[ckey].text.replace(/@-/g, '@jian').replace(/@=/g, '@deng')
              let vArry = sheet.rows[key].cells[ckey].text.match(/\d+[:=：][^\,\，\;\；]+/g)
              if (!vArry || vArry.length === 0) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              } else {
                vArry.forEach(item => {
                  let d = item.split(/[:=：]/)
                  if (d.length === 2) {
                    dp.text_en.push(d[1].replace(/@jian/g, '-').replace(/@deng/g, '='))
                  }
                })
              }
            }
          } else if (head[ckey].text === '倍率') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkInt(sheet.rows[key].cells[ckey])) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                if ((v >= -10000 && v <= -1) || (v >= 1 && v <= 10000)) {
                  if (v <= 1) {
                    dp.step = 1
                  } else {
                    dp.step = Math.round(1 / v * 1000) / 1000
                  }
                  modbus.mul = v
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              }
            }
          } else if (head[ckey].text === '偏移量') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -10000, 10000)) {
                const v = parseInt(sheet.rows[key].cells[ckey].text)
                modbus.ofs = v
              }
            }
          } else if (head[ckey].text === '上报灵敏度') {
            if (sheet.rows[key].cells[ckey].text) {
              if (!isNaN(sheet.rows[key].cells[ckey].text)) {
                const v = parseFloat(sheet.rows[key].cells[ckey].text)
                if (v >= 0.001 && v <= 1000) {
                  modbus.ech = Math.round(v * 1000) / 1000
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '实时上报') {
            if (sheet.rows[key].cells[ckey].text == '是') {
              modbus.rs = 1
            }
          } else if (head[ckey].text === '每分钟定时上报') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.ts = 1
            }
          } else if (head[ckey].text === '特殊写地址') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 65535)) {
                modbus.wad = parseInt(sheet.rows[key].cells[ckey].text)
                dp.xrw = 3
                modbus.wr = 1
              }
            }
          } else if (head[ckey].text === '特殊写功能码') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['5', '6', '15', '16']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.wfc = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '允许读失败') {
            if (sheet.rows[key].cells[ckey].text && sheet.rows[key].cells[ckey].text == '是') {
              modbus.aif = 1
            }
          } else if (head[ckey].text === '异常代码') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], -32768, 65535)) {
                modbus.ftv = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'wbit') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 14)) {
                modbus.wbit = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === '主从属性') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['主', '从', '主从']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                modbus.sub = sheet.rows[key].cells[ckey].text
                if (sheet.rows[key].cells[ckey].text == '主') {
                  dp.subhide = 1
                } else if (sheet.rows[key].cells[ckey].text == '从') {
                  dp.subhide = 2
                }
              }
            }
          } else if (head[ckey].text === '地址偏移') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 20000)) {
                modbus.suboffset = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          } else if (head[ckey].text === 'map') {
            if (sheet.rows[key].cells[ckey].text) {
              try {
                let value = JSON.parse(sheet.rows[key].cells[ckey].text)
                if (value.constructor.name === 'Array') {
                  if (value.length > 0 && value.length <= 128 && value.length % 2 === 0) {
                    modbus.map = value
                  } else {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                }
              } catch (e) {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          }
        }
        if (!dp.name) {
          dp.name = 't' + dp.dpid
        }
        if (dp.name === 'power') {
          modbusjson.prot.powerdpid = dp.dpid
        } else if (dp.name === 'softver') {
          modbusjson.prot.softverdpid = dp.dpid
        } else if (dp.name === 'slavenum') {
          slavenum = dp.dpid
        } else if (dp.name === 'modelnum') {
          modelnum = dp.dpid
        } else if (dp.name === 'subvld_1') {
          subvld_1 = dp.dpid
        }
        if (dp.values.length > 0) {
          dp.values = JSON.stringify(dp.values)
        } else {
          dp.values = null
        }
        if (dp.text.length > 0) {
          dp.text = JSON.stringify(dp.text)
        } else {
          dp.text = null
        }
        if (dp.text_en.length > 0) {
          dp.text_en = JSON.stringify(dp.text_en)
        } else {
          dp.text_en = null
        }
        if (dp.dpid && (modbus.address || modbus.address == 0) && dp.desc) {
          xml.dp.push(dp)
          modbusList.push(modbus)
        }
      }
      allRow.concat(modbusList)
      buildCmd(2)
      if (xml.submax > 1) {
        buildCmd(2, '从')
      }
    } else if (sheet.name === '故障代码') {
      let head = sheet.rows['0'].cells
      errorList = []
      for (let key in sheet.rows) {
        if (key === 'len' || key === '0') {
          continue
        }
        let error = {f: 0, bit: 0, code: 0, errorcode: '', desc: '', desc_en: '', address: '', suboffset: 0, sub: '主从'}
        for (let ckey in sheet.rows[key].cells) {
          if (head[ckey].text === '读取功能码') {
            const arry = ['1', '2', '3', '4']
            if (checkRequire(sheet.rows[key].cells[ckey]) && checkArray(sheet.rows[key].cells[ckey], arry)) {
              error.f = parseInt(sheet.rows[key].cells[ckey].text)
            }
          } else if (head[ckey].text === '协议地址') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              let value = sheet.rows[key].cells[ckey].text.split('.')
              if (value.length === 1 || value.length === 2) {
                if (value[0] && !isNaN(value[0]) && value[0] >= 0 && value[0] <= 65535) {
                  error.address = parseInt(value[0]) - (needsub1 ? 1 : 0)
                } else {
                  sheet.rows[key].cells[ckey].style = 0
                  pass = false
                  continue
                }
                if (value.length === 1) {
                  error.bit = 0
                } else {
                // 验证小数点后
                  try {
                    let value2 = JSON.parse(value[1])
                    if (value2.constructor.name === 'Number') {
                      if (value2 >= 0 && value2 <= 15) {
                        error.bit = value2
                      } else {
                        sheet.rows[key].cells[ckey].style = 0
                        pass = false
                      }
                    } else {
                      sheet.rows[key].cells[ckey].style = 0
                      pass = false
                    }
                  } catch (e) {
                    sheet.rows[key].cells[ckey].style = 0
                    pass = false
                  }
                }
              } else {
                sheet.rows[key].cells[ckey].style = 0
                pass = false
              }
            }
          } else if (head[ckey].text === '故障描述') {
            if (checkRequire(sheet.rows[key].cells[ckey])) {
              error.desc = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '故障翻译') {
            if (sheet.rows[key].cells[ckey].text) {
              error.desc_en = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '故障代码') {
            if (sheet.rows[key].cells[ckey].text) {
              error.errorcode = sheet.rows[key].cells[ckey].text
            }
          } else if (head[ckey].text === '主从属性') {
            if (sheet.rows[key].cells[ckey].text) {
              const arry = ['主', '从', '主从']
              if (checkArray(sheet.rows[key].cells[ckey], arry)) {
                error.sub = sheet.rows[key].cells[ckey].text
              }
            }
          } else if (head[ckey].text === '地址偏移') {
            if (sheet.rows[key].cells[ckey].text) {
              if (checkRange(sheet.rows[key].cells[ckey], 0, 20000)) {
                error.suboffset = parseInt(sheet.rows[key].cells[ckey].text)
              }
            }
          }
        }
        if ((error.address || error.address == 0) && error.desc) {
          if (error.f || modbusjson.prot.errcode.rule == 4 || modbusjson.prot.errcode.rule == 3 || (modbusjson.prot.errcode.rule >= 100 && modbusjson.prot.errcode.rule <= 199)) {
            errorList.push(error)
          }
        }
      }
      if (errorList.length > 0) {
        buildError()
        xml.dp.push({dpid: 9009, name: 'errorcode', desc: '故障代码', text: null, values: null, type: 2, linkagetype: 'none', max: 65535, min: 0, step: 1, unit: null, xrw: 2, desc_en: 'error code', text_en: null, groupname: '', subhide: 0, healthmax: null, healthmin: null})
      }
    }
  })
  if (pass) {
    // 配置从机
    buildSub()
  }
  if (!pass) {
    return { error: '文档填写错误，请检查红色高亮处' }
  } else if (xml.dp.length == 0 || modbusjson.prot.cmd.length == 0) {
    return { error: '文档无数据' }
  } else {
    return { mibeejson: mibeejson, modbusjson: modbusjson, uart1: uart1, uart2: uart2, xml: xml, errorcode: errorcode }
  }
}

function splitArrayOneByOne (arr) {
  if (!arr || arr.length === 0) {
    console.log('数组为空，无法拆分。')
    return []
  }
  const result = []
  let currentSubarray = []
  for (let i = 0; i < arr.length; i++) {
    const currentEle = arr[i]
    if (currentSubarray.length == 0) {
      currentSubarray.push(currentEle)
    } else {
      if (currentEle - currentSubarray[currentSubarray.length - 1] != 1) {
        result.push(currentSubarray.slice())
        currentSubarray = [currentEle]
      } else {
        currentSubarray.push(currentEle)
      }
    }
  }
  if (currentSubarray.length > 0) {
    result.push(currentSubarray)
  }
  return result
}

function splitArray (arr, count, org, type) {
  if (!arr || arr.length === 0) {
    console.log('数组为空，无法拆分。')
    return []
  }
  if (!type) {
    type = '主'
  }
  const result = []
  let currentSubarray = []

  for (let i = 0; i < arr.length; i++) {
    const currentElement = arr[i]

    if (currentSubarray.length === 0) {
      currentSubarray.push(currentElement)
    } else {
      if (currentElement - currentSubarray[0] >= count) {
        result.push(currentSubarray.slice())
        currentSubarray = [currentElement]
      } else {
        if (type === '从') {
          let checkOffset = org.filter(o => { return o.address == currentElement })[0]
          let checkOrgOffset = org.filter(o => { return o.address == currentSubarray[0] })[0]
          if (checkOffset.suboffset !== checkOrgOffset.suboffset) {
            result.push(currentSubarray.slice())
            currentSubarray = [currentElement]
            continue
          }
        }
        if (org && (currentElement - currentSubarray[0] == count - 1)) {
          let checkt = org.filter(o => { return o.address == currentElement })
          if (checkt && checkt.length > 0 && doubleType.includes(checkt[0].typ)) {
            result.push(currentSubarray.slice())
            currentSubarray = [currentElement]
          } else {
            currentSubarray.push(currentElement)
          }
        } else {
          currentSubarray.push(currentElement)
        }
      }
    }
  }

  if (currentSubarray.length > 0) {
    result.push(currentSubarray)
  }

  // 返回结果，而不是打印
  return result
}

export default validate



// WEBPACK FOOTER //
// ./src/components/Protocol/validateProtocol.js